"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesLead = exports.LeadType = void 0;
var LeadType;
(function (LeadType) {
    LeadType["TenderdTrackDemoRequest"] = "tenderd_track_demo_request";
    LeadType["MarketplaceNewOrder"] = "marketplace_new_order";
    LeadType["GoogleAdWords"] = "google_ad_words";
    LeadType["LogisticsRequest"] = "logistics_request";
    LeadType["MarketingLead"] = "marketing_lead";
    LeadType["BecomeSupplierRequest"] = "become_supplier_request";
    LeadType["ProcurementAccessRequest"] = "procurement_access_request";
    LeadType["SentOtp"] = "sent_otp";
    LeadType["BuyEquipmentRequest"] = "buy_equipment_request";
    LeadType["SellEquipmentRequest"] = "sell_equipment_request";
    LeadType["BuyEquipmentLead"] = "buy_equipment_lead";
    LeadType["SupplierSelfOnboarding"] = "supplier_self_onboarding";
})(LeadType = exports.LeadType || (exports.LeadType = {}));
exports.TypesLead = {
    tenderd_track_demo_request: LeadType.TenderdTrackDemoRequest,
    google_ad_words: LeadType.GoogleAdWords,
    logistics_request: LeadType.LogisticsRequest,
    marketing_lead: LeadType.MarketingLead,
    become_supplier_request: LeadType.BecomeSupplierRequest,
    sent_otp: LeadType.SentOtp,
    buy_equipment_request: LeadType.BuyEquipmentRequest,
    sell_equipment_request: LeadType.SellEquipmentRequest,
    buy_equipment_lead: LeadType.BuyEquipmentLead,
};
//# sourceMappingURL=lead.js.map